import { Drawer } from 'antd'
import React, { useMemo } from 'react'
import useSWR from 'swr'

import { fetcher } from '../../../api'
import { drawerAndModalWidth } from '../../../util/guideline'
import { Tenant } from '../models'
import { CreateTenant } from './CreateTenant'

interface CreateTenantProps {
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateTenantDrawer = ({ isVisible, onClose, onSuccess }: CreateTenantProps) => {
  const { data: tenants } = useSWR<Tenant[]>('/tenants', fetcher, { suspense: true })

  const segmentCodes = useMemo(() => {
    const allSegmentCodes = tenants.map(({ segmentCode }) => segmentCode)

    return Array.from(new Set(allSegmentCodes)).sort()
  }, [tenants])

  return (
    <Drawer title="Create Tenant" placement="right" onClose={onClose} open={isVisible} width={drawerAndModalWidth}>
      <CreateTenant onSuccess={onSuccess} segmentCodes={segmentCodes} />
    </Drawer>
  )
}
